export function removeItem(itemToRemove: any) {
   window.localStorage.removeItem(itemToRemove)
}

export function getItem(item: any) {
   return window.localStorage.getItem(item)
}

export function addItem(localeStorageName: any, newItem: any) {
   window.localStorage.setItem(localeStorageName, newItem)
}
